import {useState } from '@wordpress/element';
import {Icon,FlexItem, Button,Popover,
    __experimentalHStack as HStack,
    __experimentalItemGroup as ItemGroup,
    } from '@wordpress/components';
    import {shadow } from '@wordpress/icons';

import { VayuBlocksDropShadowPopup } from '@vayu-blocks/dropshadow/dropshadow-popup';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';

export const VayuBlocksDropShadow = ({
  onChange,
  label='Drop Shadow',
  dropShadow
}) => {
  const [ isVisible, setIsVisible ] = useState( false );
  const deviceView  = VayuBlocksDevice();
  const shadowValue = dropShadow?.value?.[deviceView]?.css;


// Toggle popover visibility
const toggleVisible = () => {
  setIsVisible((prev) => !prev);
}

// Handle focus outside to close popover
const onFocusOutsideClick = () => {
  setIsVisible(false);
}
const [ fixBoxShadowValue, setFixBoxShadowValue] = useState(shadowValue);

const shadowValueChange = (value) => {
  setFixBoxShadowValue(value);
}
    return (
        <div>
            <div className='vayu-blocks-drop-shadow-item'>
              <label>Shadow</label>
                <ItemGroup
                isBordered
                isSeparated
                size="large"
                onClick={ toggleVisible } 
                >
                <Button>
                <HStack alignment="left">
                  <Icon icon={shadow}
                  style={{
                    background: 'transparent',
                    border: "1px solid #e0e0e0",
                    boxShadow: fixBoxShadowValue,
                  }}
                  />

                <FlexItem>{label}</FlexItem>
                </HStack>
                </Button>
                </ItemGroup>
            </div>
            { isVisible && <Popover
              placement="left"
              position="middle left"
              offset={30}
              onFocusOutside={onFocusOutsideClick}
            >
              <VayuBlocksDropShadowPopup   
                onChange={onChange}
                label={label}
                dropShadow={dropShadow}
                shadowValueChange={(value)=>shadowValueChange(value)}
                />
              </Popover> }
         
          </div>
    );
};
